<main id="main" class="main">
  <div class="mainScreen">
    <div>
      <div class="row">
        <div
          class="form-group col-12 col-md-12 d-flex justify-content-between"
          style="
            background: 
#142A49 !important;
            font-size: 14px;
            display: flex;
            align-items: center;
            border-radius: 5px;
          "
        >
          <h6 style="font-size: 13px;background-color: 
#142A49;" class="admintitle mt-2">
            Product Catelog&nbsp;<i class="bi bi-info-circle"></i>
          </h6>
        </div>
      </div>
      <!-- filters button -->
      <div style="margin: 4px; margin-top: 7px; display: flex; gap: 6px">
        <!-- Supplier -->
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          "
        >
          <p style="font-size: 12px; font-weight: 500">Select Region</p>
          <div style="margin-top: -12px">
            <select
              [(ngModel)]="selectedRegion"
              style="
                width: 150px;
                font-size: 12px;
                padding: 4px;
                border: 1px solid #ccc;
                border-radius: 4px;
                outline: none;
              "
            >
              <option *ngFor="let region of regions">{{ region }}</option>
            </select>
          </div>
        </div>
        <!-- Product Catelog -->
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          "
        >
          <p style="font-size: 12px; font-weight: 500">Product Catelog</p>
          <div style="margin-top: -12px">
            <select
              [(ngModel)]="selectedProductCatelog"
              style="
                width: 310px;
                font-size: 12px;
                padding: 4px;
                border: 1px solid #ccc;
                border-radius: 4px;
                outline: none;
              "
            >
              <option *ngFor="let productCatelog of productCatelogs">
                {{ productCatelog }}
              </option>
            </select>
          </div>
        </div>

        <!-- Filter Plans -->
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          "
        >
          <p style="font-size: 12px; font-weight: 500">Filter Plans</p>
          <div style="margin-top: -12px">
            <div style="position: relative; width: 190px">
              <!-- Dropdown Trigger with Fake Arrow -->
              <div
                (click)="toggleDropdown()"
                style="
                  font-size: 12px;
                  padding: 4px 30px 4px 8px;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                  background-color: white;
                  cursor: pointer;
                  background-image: url('data:image/svg+xml;charset=UTF-8,<svg fill=\'%23333\' height=\'18\' viewBox=\'0 0 24 24\' width=\'18\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M7 10l5 5 5-5z\'/></svg>');
                  background-repeat: no-repeat;
                  background-position: right 8px center;
                  background-size: 12px;
                "
              >
                {{ selectedFilterplan || "Select Plan" }}
              </div>

              <!-- Dropdown Options -->
              <div
                style="
                  position: absolute;
                  top: 100%;
                  left: 0;
                  right: 0;
                  overflow: auto;
                  background: white;
                  border: 1px solid #ccc;
                  border-top: none;
                  z-index: 1000;
                  transition: max-height 0.4s ease, opacity 0.4s ease;
                "
                [style.maxHeight]="isDropdownOpen ? '200px' : '0px'"
                [style.opacity]="isDropdownOpen ? '1' : '0'"
              >
                <div
                  *ngFor="let filterplan of filterplans"
                  (click)="selectFilterPlan(filterplan)"
                  style="padding: 6px; font-size: 12px; cursor: pointer"
                  (mouseover)="hovered=filterplan"
                  [style.background]="
                    hovered === filterplan ? '#f0f0f0' : 'transparent'
                  "
                >
                  {{ filterplan }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Actions -->
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          "
        >
          <p style="font-size: 12px; font-weight: 500">Actions</p>
          <div style="margin-top: -12px">
            <select
              [(ngModel)]="selectedAction"
              style="
                width: 160px;
                font-size: 12px;
                padding: 4px;
                border: 1px solid #ccc;
                border-radius: 4px;
                outline: none;
              "
            >
              <option *ngFor="let action of actions">
                {{ action }}
              </option>
            </select>
          </div>
        </div>
        <!-- Search -->
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          "
        >
          <p style="font-size: 12px; font-weight: 500">Search</p>

          <div style="margin-top: -12px; position: relative; width: 160px">
            <input
              type="text"
              placeholder=""
              style="
                width: 100%;
                font-size: 12px;
                padding: 4px 24px 4px 6px;
                border: 1px solid #ccc;
                border-radius: 4px;
                outline: none;
              "
            />
            <span
              style="
                position: absolute;
                right: 6px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 11px;
                color: #666;
                pointer-events: none;
                margin-top: 5px;
              "
            >
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Products -->
    <div class="test">
      <div
        style="
          width: 100%;
          overflow-x: auto;
          font-family: Arial, sans-serif;
          font-size: 14px;
          margin: 13px;
          margin-right: 20px;
          margin-left: 20px;
          display: flex;
          column-gap: 10px;
        "
      >
        <!-- First Product -->
        <div
          style="
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 200px;
            max-height: fit-content;
            font-family: Arial, sans-serif;
            background-color: white;
            overflow: hidden;
            font-size: 10px;
          "
        >
          <!-- TOP HEADER -->
          <div
            style="
              background-color: #464646;
              color: white;
              padding: 6px;
              text-align: center;
              font-weight: bold;
            "
          >
            Health & Dental (1,853)
          </div>

          <!-- INNER WRAPPER -->
          <div style="padding: 6px; background-color: #eef1ff">
            <!-- Group Template START -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;All-In (615)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- Group Template END -->

            <!-- Classic Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;

                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Classic (1,112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Copper
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Flex Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Flex (112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Others Group -->
            <div>
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Others(4)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Prov Health Rep
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Second Product -->
        <div
          style="
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 200px;
            max-height: fit-content;
            font-family: Arial, sans-serif;
            background-color: white;
            overflow: hidden;
            font-size: 10px;
          "
        >
          <!-- TOP HEADER -->
          <div
            style="
              background-color: #464646;
              color: white;
              padding: 6px;
              text-align: center;
              font-weight: bold;
            "
          >
            Private Health (XXXX)
          </div>

          <!-- INNER WRAPPER -->
          <div style="padding: 6px; background-color: #eef1ff">
            <!-- Group Template START -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;All-In (615)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- Group Template END -->

            <!-- Classic Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;

                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Classic (1,112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Copper
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Flex Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Flex (112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Others Group -->
            <div>
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Others(4)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Prov Health Rep
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Third Product -->
        <div
          style="
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 200px;
            max-height: fit-content;
            font-family: Arial, sans-serif;
            background-color: white;
            overflow: hidden;
            font-size: 10px;
          "
        >
          <!-- TOP HEADER -->
          <div
            style="
              background-color: #464646;
              color: white;
              padding: 6px;
              text-align: center;
              font-weight: bold;
            "
          >
            Wellness (XXXX)
          </div>

          <!-- INNER WRAPPER -->
          <div style="padding: 6px; background-color: #eef1ff">
            <!-- Group Template START -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;All-In (615)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- Group Template END -->

            <!-- Classic Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;

                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Classic (1,112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Copper
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Flex Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Flex (112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Others Group -->
            <div>
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Others(4)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Prov Health Rep
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Forth Product -->
        <div
          style="
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 200px;
            max-height: fit-content;
            font-family: Arial, sans-serif;
            background-color: white;
            overflow: hidden;
            font-size: 10px;
          "
        >
          <!-- TOP HEADER -->
          <div
            style="
              background-color: #464646;
              color: white;
              padding: 6px;
              text-align: center;
              font-weight: bold;
            "
          >
            Life and Disability (XXXX)
          </div>

          <!-- INNER WRAPPER -->
          <div style="padding: 6px; background-color: #eef1ff">
            <!-- Group Template START -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;All-In (615)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- Group Template END -->

            <!-- Classic Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;

                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Classic (1,112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Copper
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Flex Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Flex (112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Others Group -->
            <div>
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Others(4)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Prov Health Rep
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fifth Product -->
        <div
          style="
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 200px;
            max-height: fit-content;
            font-family: Arial, sans-serif;
            background-color: white;
            overflow: hidden;
            font-size: 10px;
          "
        >
          <!-- TOP HEADER -->
          <div
            style="
              background-color: #464646;
              color: white;
              padding: 6px;
              text-align: center;
              font-weight: bold;
            "
          >
            Travel Protection (XXXX)
          </div>

          <!-- INNER WRAPPER -->
          <div style="padding: 6px; background-color: #eef1ff">
            <!-- Group Template START -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;All-In (615)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- Group Template END -->

            <!-- Classic Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;

                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Classic (1,112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Copper
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Flex Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Flex (112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Others Group -->
            <div>
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Others(4)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Prov Health Rep
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Six Product -->
        <div
          style="
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 200px;
            max-height: fit-content;
            font-family: Arial, sans-serif;
            background-color: white;
            overflow: hidden;
            font-size: 10px;
          "
        >
          <!-- TOP HEADER -->
          <div
            style="
              background-color: #464646;
              color: white;
              padding: 6px;
              text-align: center;
              font-weight: bold;
            "
          >
            Private Health (XXXX)
          </div>

          <!-- INNER WRAPPER -->
          <div style="padding: 6px; background-color: #eef1ff">
            <!-- Group Template START -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;All-In (615)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  All-in Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <!-- Group Template END -->

            <!-- Classic Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;

                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Classic (1,112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Copper
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;

                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Flex Group -->
            <div style="margin-bottom: 8px">
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Flex (112)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Bronze
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Flex Silver
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
                <div
                  style="
                    padding: 2px 4px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Classic Gold
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <!-- Others Group -->
            <div>
              <div
                style="
                  background-color: #1a3e70;
                  color: white;
                  padding: 3px 5px;
                  font-weight: bold;
                  border-radius: 4px 4px 0 0;
                  text-align: center;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span></span>

                <span>&nbsp;&nbsp;&nbsp;&nbsp;Others(4)</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="white"
                  style="cursor: pointer"
                >
                  <path
                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                  />
                </svg>
              </div>
              <div
                style="
                  border: 1px solid #b5c0d1;
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                  background-color: #ffffff;
                "
              >
                <div
                  style="
                    padding: 2px 4px;

                    display: flex;
                    justify-content: space-between;
                  "
                >
                  Prov Health Rep
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="#384C9F"
                    style="cursor: pointer"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
